import * as React from "react";
const StatusCompleteFilled = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 Z M11.2,13 L9.2,11 L8,12.2 L11.2,15.5 L16.5,10.2 L15.2,9 L11.2,13 Z" }));
StatusCompleteFilled.displayName = "StatusCompleteFilled";
var StatusCompleteFilled_default = StatusCompleteFilled;
export {
  StatusCompleteFilled_default as default
};
